import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode, VNodePropertiesWithoutIndex } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicDetails } from 'lcc-state/interfaces';
import { TopicWidgetProperties } from 'book-widgets/interfaces';

const factory = create({ theme }).properties<TopicWidgetProperties>();

export const HTMLObject = factory(({ properties, middleware: { theme } }) => {
	const { topicdata, additionalClasses = [] } = properties();
	const topicvalues: TopicDetails = topicdata as any;
	const { attributes } = topicvalues as any;

	const file = attributes.data.split('/').pop() || '';
	const path = `${window.hcstatic.portal_cdn}/files/video/${file}`;

	// TODO: add support for other file formats
	// temporary solution to support video files using `object` tag
	return v(
		'video',
		{
			autoplay: false,
			controls: true,
			controlsList: 'nodownload',
			language: window.hcstatic.portal_language || 'en',
			preload: 'auto',
			classes: [...additionalClasses],
			styles: {
				maxWidth: '80%'
			}
		},
		[
			v('source', {
				src: path,
				type: 'video/mp4'
			})
		]
	);
});
